import JSZip from "jszip";
import { LOGOS, FONTS, IMAGES, brandGuideText } from "@/lib/brand";

const fetchBlob = async (url) => {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`${url} returned HTTP ${r.status}`);
  return r.blob();
};

export const downloadBrandKit = async () => {
  const zip = new JSZip();
  const jobs = [
    ...LOGOS.flatMap((l) => ["svg", "png"].map((ext) => [`logos/aerosoft-${l.id}.${ext}`, `/brand/aerosoft-${l.id}.${ext}`])),
    ...FONTS.flatMap((f) => f.files.map((file) => [`fonts/${file}`, `/brand/fonts/${file}`])),
    ...IMAGES.map((i) => [`images/${i.file}`, `/img/${i.file}`]),
  ];
  await Promise.all(jobs.map(async ([path, url]) => zip.file(path, await fetchBlob(url))));
  zip.file("BRAND-GUIDE.txt", brandGuideText());
  const blob = await zip.generateAsync({ type: "blob" });
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: "AeroSoftSolutions-BrandKit.zip" });
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
